/*
 *
 * Do not edit directly
 * Generated on Mon, 24 Jun 2024 16:18:26 GMT
 *
 */


const theme = {
  appearances: {
    checked: {
      description: 'Corresponds to a selected state for a checkbox or radio',
      type: 'state',
      values: [ true ]
    },
    error: { type: 'state', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    { if: { error: true }, tokens: {} },
    { if: { hover: true }, tokens: { outerBorderColor: '#e3e6e8' } },
    {
      if: { focus: true },
      tokens: { inputBorderColor: '#7c53a5', inputBorderWidth: 3 }
    },
    {
      if: { inactive: true },
      tokens: {
        inputBackgroundColor: '#e3e6e8',
        inputBorderColor: 'rgba(0, 0, 0, 0)',
        labelColor: '#676e73'
      }
    },
    {
      if: { checked: true, inactive: true },
      tokens: {
        checkedBackgroundColor: '#b2b9bf',
        inputBackgroundColor: '#ffffff',
        inputBorderColor: '#b2b9bf',
        labelColor: '#676e73'
      }
    }
  ],
  tokens: {
    checkedBackgroundColor: '#7c53a5',
    checkedSize: 12,
    containerBackgroundColor: 'rgba(0, 0, 0, 0)',
    containerBorderRadius: 0,
    containerOpacity: 1,
    containerPaddingBottom: 0,
    containerPaddingLeft: 2,
    containerPaddingRight: 0,
    containerPaddingTop: 0,
    containerShadow: null,
    descriptionFontName: 'HelveticaNow',
    descriptionFontSize: 14,
    descriptionFontWeight: '400',
    descriptionLineHeight: 1.42857142857,
    descriptionMarginLeft: null,
    icon: null,
    iconBackgroundColor: 'rgba(0, 0, 0, 0)',
    iconColor: 'rgba(0, 0, 0, 0)',
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#676e73',
    inputBorderWidth: 1,
    inputOutlineColor: 'rgba(0, 0, 0, 0)',
    inputOutlineWidth: 0,
    inputSize: 20,
    labelColor: '#414547',
    labelFontName: 'HelveticaNow',
    labelFontSize: 16,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    labelMarginLeft: 10,
    outerBorderColor: 'transparent',
    outerBorderGap: 0,
    outerBorderWidth: 2
  }
}
export default theme
